import { useAuth } from '../core/Auth';
import Box from '@mui/material/Box';
import { Button, Typography, useTheme } from '@mui/material';
import logoImg from '../../../assets/img/logo.svg';
import './login.css';
import { LoginForm } from './FomLogin';
import Layer1 from './Layer1';
import Layer2 from './Layer2';
import Layer3 from './Layer3';
import { useNavigate } from 'react-router-dom';
const Login = () => {
  const theme = useTheme();
  const { saveAuth, setCurrentUser } = useAuth();

  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/about');
  };
  return (
    <Box
      className='w-[510px] h-[630px] flex flex-col      border-[1px]  rounded-[40px]  bg-red-800 relative '
      sx={{
        backgroundColor: '#fff',
        width: '510px',
      }}
    >
      <Button
        onClick={handleClick}
        className=' flex flex-col  items-center flex-grow    overflow-hidden r outline-none   '
        style={{ zIndex: 1 }}
        title='About us'
        sx={{
          background: '#fff',
          '&:hover': {
            background: theme.palette.secondary.main,
            boxShadow: '10px 10px 20px 0 rgba(256,256,256,0.25)',
          },
          borderTopRightRadius: '40px',
          borderTopLeftRadius: '40px',
          boxShadow: '10px 10px 20px 0 rgba(256,256,256,0.25)',
        }}
      >
        <Box className='flex flex-col justify-center items-center flex-grow cursor-pointer text-center  '>
          <img src={logoImg} alt='logo' width='100%' className=' max-h-[118px] min-h-[118px]' />
          <Typography
            className='text-center text-[20px]  fw-bold  relative  '
            sx={{
              color: theme.palette.primary.main,
            }}
          >
            Sign in to Tazmeen Ai
          </Typography>
        </Box>
      </Button>

      <Box
        className=' relative  w-full  min-h-[375px]  max-h-[375px] justify-center items-center  shadow-[10px_10px_20px_0_rgba(256,256,256,0.25)   flex flex-col rounded-[40px]  '
        sx={{
          boxShadow: '10px 10px 20px 0 rgba(256,256,256,0.25)',
        }}
      >
        <LoginForm />
      </Box>
      <Layer1 />
      <Layer2 />
      <Layer3 />
    </Box>
  );
};

export default Login;
